module.exports = {"StatusCode":200,"Payload":"[[]]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/fetchUserFiles.json
// module id = +GVM
// module chunks = 0